import Sacrificer from '../../helpers/sacrificer';
import MubinApiServices from '../../services/MubinApi'

export const state = {
    sacrificer: null,
}

export const mutations = {
    setSacrificer(state, sacrificer) {
        state.sacrificer = sacrificer
    }
}

export const getters = {
    getSacrificer(state){
        return state.sacrificer != null ? 
        new Sacrificer(
            state.sacrificer.personCode,
            state.sacrificer.firstName,
            state.sacrificer.secondName,
            state.sacrificer.thirdName,
            state.sacrificer.fourthName,
            state.sacrificer.familyName,
            state.sacrificer.motherName,
            state.sacrificer.currentAccommodation,
            state.sacrificer.category,
            state.sacrificer.category == 'مستفيد'?
                new Sacrificer(/* for martyr */
                    state.sacrificer.sacrificer.personCode,
                    state.sacrificer.sacrificer.firstName,
                    state.sacrificer.sacrificer.secondName,
                    state.sacrificer.sacrificer.thirdName,
                    state.sacrificer.sacrificer.fourthName,
                    state.sacrificer.sacrificer.familyName,
                    state.sacrificer.sacrificer.motherName,
                    state.sacrificer.sacrificer.currentAccommodation,
                    state.sacrificer.sacrificer.category,
                    null
                ):null
        ) : null
    }
}

export const actions = {

    validate( { commit }, { code } = {}) {
        //clear old info
        commit('setSacrificer', null);

        return MubinApiServices.checkcode(code)
        .then((response)=>{
            const data = response.data
            commit('setSacrificer', data);

            if(data.category != 'مستفيد'){
                throw new Error("code : 500")
            }

            return response.status;
        })
        .catch(()=>{
            return 500;
        })
    },
}
